module.exports = __webpack_public_path__ + "img/accounting.3f9c6bf6.svg";